
import { UserManager } from 'oidc-client';
import configurations from '~/plugins/oidc-client-config.js';
import TruckListItem from '~/components/find-my-truck/TruckListItem.vue';
import TruckFilter from '~/components/find-my-truck/TruckFilter.vue';
// import GetQuoteModal from '~/components/modal/GetQuoteModal';
import MoonLoader from 'vue-spinner/src/MoonLoader.vue';
import { configs } from '../../config/config.keys';
import CreateTruckModal from '../../components/modal/CreateTruckModal.vue';
import { CARRIER, SHIPPER } from '../../util/constants';

export default {
  components: {
    TruckListItem,
    TruckFilter,
    // GetQuoteModal,
    MoonLoader,
    CreateTruckModal
  },
  props: {
    modalShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      sortBy: 'Newest',
      pickupLocation: {
        suburb: ''
      },
      deliveryLocation: {
        suburb: ''
      },
      state: [],
      selectedCategory: [],
      selectedEquipmentType: [],
      truckList: [],
      isModalVisible: false,
      isLoading: false,
      CARRIER,
    };
  },
  head() {
    return {
      title: 'Truck Transportation: Get Truck Transport Quotes',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Find loads for transportation across Australia with our transport marketplace. Shippers and carriers can connect and save time and money. Get started today.'
        }
      ]
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.user.currentUser;
    },
    isFilterVisible(){
      return!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
    }
  },
  watch: {
    currentUser: {
      handler() {
        if(this.currentUser && this.currentUser.role == 'Carrier') {
          this.getTrucks()
        }
      },
      deep: true,
    }
  },
  created() {
    if (!process.server) {
      this.userMgr = new UserManager(configurations.authConfigLogin);
    }
    this.isLoading = true
    setTimeout(() => {
      this.getTrucks();
    }, 1000)
  },
  methods: {
    filterChanged(value) {
      this.selectedCategory = value.cargoCategory ? value.cargoCategory : []
      this.selectedEquipmentType = value.equipmentType ? value.equipmentType : []
      this.state = value.state ? value.state : []
      if(value.pickup.suburb) {
        this.pickupLocation.suburb = value.pickup.suburb.suburb
      } else {
        this.pickupLocation.suburb = value.pickup.suburb
      }
      if(value.delivery.suburb) {
        this.deliveryLocation.suburb = value.delivery.suburb.suburb
      } else {
        this.deliveryLocation.suburb = value.delivery.suburb
      }
    },
    sortChanged (value) {
      this.sortBy = value
      this.getTrucks()
    },
    isSortActive(value){
      return this.sortBy === value
    },
    isIncompleteUser(){
      if(!this.currentUser){
        this.showSignUpModal();
        return true;
      } else if(this.currentUser && this.currentUser.role == CARRIER && !this.currentUser.emailConfirmed){
        this.showEmailModal()
        return true;
      } else{
        return false;
      }
    },
    pageChange(e) {
      if(this.isIncompleteUser()){
        return;
      }
      this.currentPage = e
      this.getTrucks(e)
    },
    search(){
      if(this.isIncompleteUser()){
        return;
      }
      this.getTrucks()
    },
    async getTrucks(currentPage=1){
      this.isLoading = true
      const payload = {
        userId: this.currentUser ? this.currentUser.role === 'Carrier' ? this.currentUser.id : null : null,
        user: this.$store.state.user,
        location: this.pickupLocation.suburb ? this.pickupLocation.suburb : '',
        delivery: this.deliveryLocation.suburb ? this.deliveryLocation.suburb : '',
        states: this.state,
        truckTypes : this.selectedEquipmentType,
        category: this.selectedCategory,
        orderBy: this.sortBy.toLowerCase(),
        pageNumber: currentPage,
        pageSize: this.pageSize
      }

      const actionItem = this.currentUser ? this.currentUser.role === 'Carrier' ? 'getCarrierTruckList' : 'getTruckList' : 'getTruckList'
      this.$store.dispatch(`truck/${actionItem}`, payload).then((res) => {
        this.truckList = res
        if(this.currentUser == null || (this.currentUser && this.currentUser.role === 'Shipper')) {
          this.truckList.result = this.truckList.result.filter(e => e.truckStatus != 2)
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    showQuoteModal() {
      if(this.isIncompleteUser()){
        return;
      }
      this.isModalVisible = true;
    },
    closeQuoteModal() {
      this.isModalVisible = false;
    },
    showSignUpModal(){
      const msgBody = 'Utransport provides free access to carriers and shippers, Sign in or Register to view more'
      this.$bvModal.msgBoxConfirm(msgBody, {
        title: 'Join Utransport to see more',
        cancelVariant:'primary',
        okVariant:'secondary',
        okTitle: 'Register',
        cancelTitle: 'Sign In',
        hideHeaderClose: false,
        centered: true,
        contentClass: 'quote-modal',
        bodyClass: 'form-componant',
        noCloseOnBackdrop: true
      })
      .then(value => {
        if(value){
          this.signUp();
        }
        else if (value == false){
          this.login();
        }
      })
    },
    showCarrierSignUpModal(){
      const msgBody = 'Creating a listing is exclusively available to our carriers. If you are a carrier you can continue below.'
      this.$bvModal.msgBoxConfirm(msgBody, {
        title: 'Create Listing',
        cancelVariant:'primary',
        okVariant:'secondary',
        okTitle: 'Join as a carrier',
        cancelTitle: 'Sign in as a carrier',
        hideHeaderClose: false,
        centered: true,
        contentClass: 'quote-modal',
        bodyClass: 'form-componant',
        noCloseOnBackdrop: true
      })
      .then(value => {
        if(value){
          this.logOutToSignUp()
        }
        else if(value == false){
          this.logout();
        }
      })
    },
    showSubscribeModal(){
      const msgBody = 'Please subscribe to gain full functionality to your Utransport portal.'
      this.$bvModal.msgBoxOk(msgBody, {
        title: 'Subscribe to see more',
        cancelVariant:'primary',
        okVariant:'secondary',
        okTitle: 'Subscribe',
        hideHeaderClose: false,
        centered: true,
        contentClass: 'quote-modal',
        bodyClass: 'form-componant',
        noCloseOnBackdrop: true
      })
      .then(value => {
        if(value){
          this.redirectToSubscription();
        }
      })
    },
    showEmailModal(){
      const msgBody = 'Please verify your email address to gain full functionality to your Utransport portal. You may click the link on the page to resend the email again.'
      this.$bvModal.msgBoxOk(msgBody, {
        title: 'Verify email to see more',
        cancelVariant:'primary',
        okVariant:'secondary',
        okTitle: 'Close',
        hideHeaderClose: true,
        centered: true,
        contentClass: 'quote-modal',
        bodyClass: 'form-componant',
        noCloseOnBackdrop: true
      })
    },
    login() {
      return this.userMgr.signinRedirect({ state: 'dskjqmoiqQdjnJHOnGn' });
    },
    signUp() {
      window.location.href =
        configs.signupUrl;
    },
    redirectToSubscription(){
      this.$router.push({
        path: '/settings/subscription'
      });
    },
    logout() {
      this.$store.dispatch('messages/unsubscribeToMessages');
      this.userMgr.signoutRedirect({
        id_token_hint: localStorage.getItem('id_token'),
        state: 'abcdefg',
      });
      localStorage.clear();
      sessionStorage.clear();
    },
    logOutToSignUp(){
      this.userMgr = new UserManager(configurations.authConfigLoadSignup);
      this.logout()
    },
  }
}
